/**
 * Complementary products - checkboxes, total price update, product description popup, add to cart
 */
(function () {
  function formatMoney(cents, format) {
    if (!format) format = '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, (cents / 100).toFixed(0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function initComplementaryProducts(container) {
    if (!container) return;

    const mainVariantsEl = container.querySelector('.complementary-products__main-variants');
    const checkboxes = container.querySelectorAll('.cc-test-product');
    const modal = container.querySelector('modal-dialog.complementary-product-modal');
    const modalTitle = modal?.querySelector('.complementary-product-modal__title');
    const modalDesc = modal?.querySelector('.complementary-product-modal__description');
    const modalImage = modal?.querySelector('.complementary-product-modal__image');
    const modalImageWrapper = modal?.querySelector('.complementary-product-modal__image-wrapper');

    if (!mainVariantsEl || !checkboxes.length) return;

    let mainProductData;
    try {
      mainProductData = JSON.parse(mainVariantsEl.textContent);
    } catch (e) {
      return;
    }

    const moneyFormat = mainProductData.moneyFormat || '${{amount}}';
    const variantPrices = mainProductData.variantPrices || {};

    function getMainProductPrice() {
      const productForm = container.closest('.js-product')?.querySelector('.js-product-form-main');
      const variantInput = productForm?.querySelector('input[name="id"]');
      const variantId = variantInput?.value;
      if (!variantId || !variantPrices[variantId]) return 0;
      return parseInt(variantPrices[variantId], 10);
    }

    function getMainProductQuantity() {
      const productForm = container.closest('.js-product')?.querySelector('.js-product-form-main');
      const qtyEl = productForm?.querySelector('[name="quantity"]');
      return parseInt(qtyEl?.value || '1', 10);
    }

    function getMainProductPriceEl() {
      const productSection = container.closest('.js-product');
      return productSection?.querySelector('.product-info__price .price__default .price__current') ||
        productSection?.querySelector('.product-info__price .price__current');
    }

    function getSelectedOptionsForItem(item) {
      const inputs = item.querySelectorAll('.complementary-products__option-input:checked');
      const opts = [];
      inputs.forEach(function (inp) {
        opts[parseInt(inp.dataset.optionIndex, 10)] = inp.value;
      });
      return opts;
    }

    function findVariantForItem(item) {
      const variantsDataEl = item.querySelector('.complementary-products__variant-data');
      if (!variantsDataEl) return null;
      let variants;
      try {
        variants = JSON.parse(variantsDataEl.textContent);
      } catch (e) {
        return null;
      }
      const selectedOpts = getSelectedOptionsForItem(item);
      for (let i = 0; i < variants.length; i++) {
        const v = variants[i];
        let match = true;
        for (let j = 0; j < selectedOpts.length; j++) {
          const optVal = selectedOpts[j];
          const vOpt = v['option' + (j + 1)];
          if (optVal !== vOpt) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return variants.length > 0 ? variants[0] : null;
    }

    function getVariantIdForItem(item) {
      const variantsDiv = item.querySelector('.complementary-products__variants');
      if (variantsDiv && !variantsDiv.classList.contains('hidden')) {
        const v = findVariantForItem(item);
        return v ? v.id : null;
      }
      const cb = item.querySelector('.cc-test-product');
      return cb && cb.checked ? parseInt(cb.dataset.variantId, 10) : null;
    }

    function getQuantityForItem(item) {
      const qtyInput = item.querySelector('.complementary-products__quantity-input');
      const qty = parseInt(qtyInput?.value || '1', 10);
      return qty > 0 ? qty : 1;
    }

    function getUnitPriceForItem(item) {
      const cb = item.querySelector('.cc-test-product');
      if (!cb || !cb.checked) return 0;

      // If a bundle discount widget (e.g. complementary-products-bundle-savings)
      // has computed a discounted unit price for this item, the main product
      // total and sticky bar should reflect it too.
      if (cb.dataset.discountedPrice !== undefined) {
        return parseInt(cb.dataset.discountedPrice, 10) || 0;
      }

      const variantsDiv = item.querySelector('.complementary-products__variants');
      if (variantsDiv && !variantsDiv.classList.contains('hidden')) {
        const v = findVariantForItem(item);
        return v ? parseInt(v.price || '0', 10) : 0;
      }
      return parseInt(cb.dataset.price || '0', 10);
    }

    function getLineTotalForItem(item) {
      return getUnitPriceForItem(item) * getQuantityForItem(item);
    }

    function getDisplayUnitPriceForItem(item) {
      const variantsDiv = item.querySelector('.complementary-products__variants');
      if (variantsDiv && !variantsDiv.classList.contains('hidden')) {
        const v = findVariantForItem(item);
        return v ? parseInt(v.price || '0', 10) : 0;
      }
      const cb = item.querySelector('.cc-test-product');
      return cb ? parseInt(cb.dataset.price || '0', 10) : 0;
    }

    function updatePriceDisplayForItem(item) {
      const cb = item.querySelector('.cc-test-product');
      const priceSpan = item.querySelector('.complementary-products__price');
      if (!cb || !priceSpan) return;

      // A bundle discount widget (e.g. complementary-products-bundle-savings)
      // owns this item's price markup once it's active - don't clobber it.
      if (cb.dataset.discountedPrice !== undefined) return;

      const lineTotal = getDisplayUnitPriceForItem(item) * getQuantityForItem(item);
      priceSpan.textContent = '(' + formatMoney(lineTotal, moneyFormat) + ')';
    }

    function getSelectedComplementaryTotal() {
      let total = 0;
      const items = container.querySelectorAll('.complementary-products__item');
      items.forEach(function (item) {
        const cb = item.querySelector('.cc-test-product');
        if (cb && cb.checked) {
          total += getLineTotalForItem(item);
        }
      });
      return total;
    }

    function getSelectedComplementaryItems() {
      const selected = [];
      const items = container.querySelectorAll('.complementary-products__item');
      items.forEach(function (item) {
        const cb = item.querySelector('.cc-test-product');
        if (cb && cb.checked) {
          const vid = getVariantIdForItem(item);
          if (vid) selected.push({ id: vid, quantity: getQuantityForItem(item) });
        }
      });
      return selected;
    }

    function updateTotal() {
      const mainPrice = getMainProductPrice();
      const quantity = getMainProductQuantity();
      const complementaryTotal = getSelectedComplementaryTotal();
      const grandTotal = mainPrice * quantity + complementaryTotal;

      const mainPriceEl = getMainProductPriceEl();
      if (mainPriceEl) {
        mainPriceEl.textContent = formatMoney(grandTotal, moneyFormat);
      }

      document.dispatchEvent(new CustomEvent('complementary-products:total-updated', { detail: { totalFormatted: formatMoney(grandTotal, moneyFormat) } }));
    }

    function openModal(productId, openerBtn) {
      const dataEl = container.querySelector('.complementary-product-data[data-product-id="' + productId + '"]');
      if (!modal || !dataEl || !modalTitle || !modalDesc) return;

      const titleEl = dataEl.querySelector('.complementary-product-data__title');
      const descriptionEl = dataEl.querySelector('.complementary-product-data__description');
      const imageUrl = dataEl.dataset.imageUrl || '';
      const title = titleEl ? titleEl.textContent : '';
      const description = descriptionEl ? descriptionEl.innerHTML : '';

      modalTitle.textContent = title;
      modalDesc.innerHTML = description || '<p>No description available.</p>';

      if (modalImage && modalImageWrapper) {
        if (imageUrl) {
          modalImage.src = imageUrl;
          modalImage.alt = title;
          modalImageWrapper.hidden = false;
        } else {
          modalImage.src = '';
          modalImage.alt = '';
          modalImageWrapper.hidden = true;
        }
      }

      if (typeof modal.open === 'function') {
        modal.open(openerBtn);
      }
    }

    function toggleVariantsForItem(item, show) {
      const variantsDiv = item.querySelector('.complementary-products__variants');
      const cb = item.querySelector('.cc-test-product');

      if (!variantsDiv) return;
      variantsDiv.classList.toggle('hidden', !show);

      if (show) {
        const v = findVariantForItem(item);
        if (cb && v) {
          cb.dataset.variantId = v.id;
          cb.dataset.price = v.price || '0';
        }
      } else if (cb) {
        const variantsDataEl = item.querySelector('.complementary-products__variant-data');
        var firstPrice = cb.dataset.price || '0';
        if (variantsDataEl) {
          try {
            const variants = JSON.parse(variantsDataEl.textContent);
            const first = variants.find(function (v) { return v.available; }) || variants[0];
            if (first) firstPrice = first.price || '0';
          } catch (e) {}
        }
        cb.dataset.price = firstPrice;
      }

      updatePriceDisplayForItem(item);
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        const item = checkbox.closest('.complementary-products__item');
        if (item && item.dataset.hasVariants === 'true') {
          toggleVariantsForItem(item, checkbox.checked);
        }
        updateTotal();
      });
    });

    container.addEventListener('click', function (e) {
      const nameBtn = e.target.closest('.complementary-products__name');
      if (nameBtn && nameBtn.dataset.productId) {
        e.preventDefault();
        e.stopPropagation();
        openModal(nameBtn.dataset.productId, nameBtn);
      }
    });

    container.addEventListener('input', function (e) {
      const qtyInput = e.target.closest('.complementary-products__quantity-input');
      if (qtyInput) {
        const item = qtyInput.closest('.complementary-products__item');
        if (item) updatePriceDisplayForItem(item);
        updateTotal();
      }
    });

    container.addEventListener('change', function (e) {
      const qtyInput = e.target.closest('.complementary-products__quantity-input');
      if (qtyInput) {
        const item = qtyInput.closest('.complementary-products__item');
        if (item) updatePriceDisplayForItem(item);
        updateTotal();
        return;
      }
      const input = e.target.closest('.complementary-products__option-input');
      if (!input) return;
      const item = input.closest('.complementary-products__item');
      if (!item) return;
      const cb = item.querySelector('.cc-test-product');
      const v = findVariantForItem(item);
      if (cb && v) {
        cb.dataset.variantId = v.id;
        cb.dataset.price = v.price || '0';
      }
      updatePriceDisplayForItem(item);
      updateTotal();
    });

    document.addEventListener('on:variant:change', function (e) {
      if (container.closest('.js-product') && container.closest('.js-product').contains(e.target)) {
        updateTotal();
      }
    });

    const productForm = container.closest('.js-product')?.querySelector('.js-product-form-main');
    const qtyEl = productForm?.querySelector('[name="quantity"]');
    if (qtyEl) {
      qtyEl.addEventListener('change', updateTotal);
      qtyEl.addEventListener('input', updateTotal);
    }

    container._getSelectedComplementaryItems = getSelectedComplementaryItems;
    container._openDescriptionModal = openModal;
    updateTotal();
  }

  var addToCartInterceptorSetup = false;

  function setupAddToCartInterceptor() {
    if (addToCartInterceptorSetup) return;
    addToCartInterceptorSetup = true;
    document.addEventListener('submit', function (evt) {
      const form = evt.target;
      if (!form || !form.classList.contains('js-product-form-main')) return;

      const productSection = form.closest('.js-product');
      if (!productSection) return;

      const complementaryContainer = productSection.querySelector('.complementary-products-checkboxes');
      if (!complementaryContainer || !complementaryContainer._getSelectedComplementaryItems) return;

      const complementaryItems = complementaryContainer._getSelectedComplementaryItems();
      if (complementaryItems.length === 0) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      const productForm = form.closest('product-form');
      const submitBtn = productForm?.querySelector('[name="add"]');
      const errorMsg = productForm?.querySelector('.js-form-error');
      const cartDrawer = document.querySelector('cart-drawer');

      let sections = 'cart-icon-bubble';
      if (cartDrawer) {
        const drawerSectionId = cartDrawer.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        if (drawerSectionId) sections += ',' + drawerSectionId;
      }

      const variantId = parseInt(form.querySelector('input[name="id"]')?.value, 10);
      const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);

      if (!variantId) return;

      const items = [{ id: variantId, quantity: quantity }];
      complementaryItems.forEach(function (complementaryItem) {
        items.push({ id: complementaryItem.id, quantity: complementaryItem.quantity });
      });

      const payload = {
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      };

      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('is-loading');
      }
      if (errorMsg) {
        errorMsg.hidden = true;
        errorMsg.innerHTML = '';
      }

      fetch(typeof theme !== 'undefined' && theme.routes ? theme.routes.cartAdd : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (_a) {
          var ok = _a.ok, data = _a.data;
          if (!ok && data.description) {
            if (errorMsg) {
              errorMsg.textContent = typeof data.description === 'string' ? data.description : data.message || '';
              errorMsg.hidden = false;
            }
            return;
          }
          if (data.errors && typeof data.errors === 'object') {
            var errText = Object.entries(data.errors).map(function (e) { return e[1].join(', '); }).join(' ');
            if (errorMsg) {
              errorMsg.textContent = errText;
              errorMsg.hidden = false;
            }
            return;
          }
          if (typeof theme !== 'undefined' && theme.settings && theme.settings.afterAtc === 'page') {
            window.location.href = (typeof theme !== 'undefined' && theme.routes ? theme.routes.cart : '/cart');
            return;
          }
          if (data.sections) {
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && data.sections['cart-icon-bubble']) {
              cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
            }
            if (cartDrawer && cartDrawer.renderContents) {
              const shouldOpen = typeof theme !== 'undefined' && theme.settings && theme.settings.afterAtc === 'drawer';
              setTimeout(function () {
                cartDrawer.renderContents(data, shouldOpen);
              }, 700);
            }
          }
        })
        .catch(function (err) {
          console.error(err);
          if (errorMsg) {
            errorMsg.textContent = 'Unable to add items to cart. Please try again.';
            errorMsg.hidden = false;
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.classList.add('is-success');
            submitBtn.removeAttribute('aria-disabled');
            setTimeout(function () {
              submitBtn.classList.remove('is-loading');
              submitBtn.classList.remove('is-success');
            }, 1400);
          }
        });
    }, true);
  }

  function setupDescriptionPopupDelegation() {
    document.addEventListener('click', function (e) {
      const nameBtn = e.target.closest('.complementary-products__name');
      if (!nameBtn || !nameBtn.dataset.productId) return;

      const container = nameBtn.closest('.complementary-products-checkboxes');
      if (!container || !container._openDescriptionModal) return;

      e.preventDefault();
      e.stopPropagation();
      container._openDescriptionModal(nameBtn.dataset.productId, nameBtn);
    });
  }

  const processedContainers = new WeakSet();

  function init() {
    document.querySelectorAll('.complementary-products-checkboxes').forEach(function (container) {
      if (!processedContainers.has(container)) {
        processedContainers.add(container);
        initComplementaryProducts(container);
      }
    });
  }

  function observeRecommendations() {
    const recommendations = document.querySelectorAll('product-recommendations[data-url*="intent=complementary"]');
    recommendations.forEach(function (el) {
      if (el._complementaryObserved) return;
      el._complementaryObserved = true;
      const observer = new MutationObserver(function () {
        init();
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupDescriptionPopupDelegation();
      setupAddToCartInterceptor();
      init();
      observeRecommendations();
      setTimeout(init, 500);
      setTimeout(init, 1500);
    });
  } else {
    setupDescriptionPopupDelegation();
    setupAddToCartInterceptor();
    init();
    observeRecommendations();
    setTimeout(init, 500);
    setTimeout(init, 1500);
  }

  document.addEventListener('shopify:section:load', init);
})();
